<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>edit</mat-icon> Edit Voucher: {{voucher.voucherId}}
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">&nbsp;</div>
</div>

<div *ngIf="!loading">
  <mat-tab-group dynamicHeight mat-align-tabs="begin" animationDuration="0ms" color="primary">
    <!-- Voucher -->
    <mat-tab label="Voucher">
      <br />
      <form [formGroup]="voucherForm">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" *ngIf="showStatusWarning">
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
            <div fxFlex="100" fxFlex.lt-sm="100">
              <div class="bg-red-400 p-8 text-light ng-star-inserted" style="flex-direction: row; box-sizing: border-box; display: flex;">
                <p>
                  <span *ngIf="voucherForm.get('applicationStatus').value == voucherService.waitlist">
                    <strong>Warning:&nbsp;</strong>Changing the voucher application status from
                    <strong>&nbsp;{{voucherService.issued}}&nbsp;</strong> to
                    <strong>&nbsp;{{this.voucherForm.get('applicationStatus').value}}</strong>
                    will result in the voucher being removed and setting the intial application status to
                    <strong>&nbsp;{{this.voucherForm.get('applicationStatus').value}}.</strong>
                    <br /> All associated letters and samples will also be deleted. For Duplicate vouchers, consider the
                    voucher merge feature on the search page.
                  </span>
                  <span *ngIf="voucherForm.get('applicationStatus').value == voucherService.duplicate">
                    <strong>Warning:&nbsp;</strong>Changing the voucher application status from
                    <strong>&nbsp;{{voucherService.issued}}&nbsp;</strong> to
                    <strong>&nbsp;{{this.voucherForm.get('applicationStatus').value}}</strong>
                    will result in the voucher being unissued and setting the intial application status to
                    <strong>&nbsp;{{this.voucherForm.get('applicationStatus').value}}.</strong>
                  </span>

                </p>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">&nbsp;</div>
        </div>

        <div fxLayout="row" fxLayoutAlign="none" fxLayout.lt-sm="column" fxLayoutGap="8px">
          <!-- Voucher info -->
          <div fxLayout="column" fxLayoutAlign=" center" fxLayoutGap="8px">
            <mat-card>
              <mat-card-title>
                <span>Voucher Information</span>
              </mat-card-title>
              <mat-card-content>
                <div fxLayout="column" fxLayoutGap="8px">
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                    <div fxFlex="100" fxFlex.lt-sm="100">
                      {{voucher.voucherId}}
                    </div>
                  </div>
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                    <div fxFlex="100" fxFlex.lt-sm="100">
                      <em>Issued on {{voucher.createDate}} </em>
                    </div>
                  </div>

                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                          <mat-label>Status</mat-label>
                          <mat-select formControlName="applicationStatus" (selectionChange)="statusChange()">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let item of voucherStatuses" value="{{item}}">{{item}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Max Voucher Value" formControlName="voucherMaxValue">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                    <div fxFlex="100" fxFlex.lt-sm="100">
                      <strong>Treatment Voucher: </strong>
                      <mat-checkbox formControlName="treatment"></mat-checkbox>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" *ngIf="voucherForm.value.treatment">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Max Treatment Value" formControlName="voucherTreatementMaxValue">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                    <div fxFlex="100" fxFlex.lt-sm="100">
                      <strong>Type: </strong> {{voucher.voucherApplication.applicationType}}
                    </div>
                  </div>

                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                    <div fxFlex="100" fxFlex.lt-sm="100">
                      <strong>Exceedances: </strong>
                      <mat-checkbox formControlName="exceedencesDetected"></mat-checkbox>
                    </div>
                  </div>
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                    <div fxFlex="100" fxFlex.lt-sm="100">
                      <strong>Redeemed: </strong>
                      <mat-checkbox formControlName="redeemed"></mat-checkbox>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Voucher contact info -->
          <div fxLayout="column" fxLayoutAlign=" center" fxLayoutGap="8px">
            <mat-card>
              <mat-card-title>
                <span>Contact Information</span>
              </mat-card-title>
              <mat-card-content>
                <div fxLayout="column" fxLayoutGap="8px">
                  <!-- name -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Contact Name" formControlName="applicantContactName">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <!-- Email/Phone -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Contact Phone" formControlName="applicantContactPhone">
                        </mat-form-field>
                      </div>
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Contact Email" formControlName="applicantContactEmail">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- contact method/comments -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                          <mat-label>Contact Method</mat-label>
                          <mat-select formControlName="preferredContactType">
                            <mat-option value=""></mat-option>
                            <mat-option *ngFor="let item of voucherService.contactMethods" value="{{item}}">{{item}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <textarea matInput placeholder="Contact Method Comments" formControlName="preferredContactComments"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <!-- address unit -->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <!-- <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Applicant Address Unit #" formControlName="applicantAddressUnit">
                        </mat-form-field>
                      </div>
                    </div> -->
                  </div>

                  <!-- address / city-->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Applicant Mailing Address" formControlName="applicantAddress">
                        </mat-form-field>
                      </div>
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Applicant Mailing City" formControlName="applicantCity">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- state / zip-->
                  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Applicant Mailing State" formControlName="applicantState">
                        </mat-form-field>
                      </div>
                      <div fxFlex="100" fxFlex.lt-sm="100">
                        <mat-form-field>
                          <input matInput placeholder="Applicant Mailing Zip" formControlName="applicantZip">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- Voucher buttons -->
        <div fxLayout="row" fxLayoutAlign="none" fxLayoutGap="8px">
          <button mat-raised-button [disabled]="processing || loading" color="primary" (click)="saveVoucher()" [disabled]="authService.isReadOnly()">Update
            Voucher</button>
          &nbsp;
          <em fxHide fxShow.gt-sm><small>Last updated on {{voucher?.modifiyDate}} by {{voucher?.modifiedBy}}</small>
          </em>
        </div>

        <!-- Edit info -->
        <div fxLayout="row" fxLayoutAlign="left" fxLayoutGap="8px">
        </div>
      </form>
    </mat-tab>

    <!-- Applications -->
    <mat-tab label="Application">
      <br />
      <application-edit [applicationId]="voucher.voucherApplication.id"></application-edit>
    </mat-tab>

    <!-- Letters -->
    <mat-tab label="Letters">
      <voucher-letters [voucherId]="voucher.id"></voucher-letters>
    </mat-tab>

    <!-- Household -->
    <mat-tab label="Households">
      <br />
      <household-associations [wellId]="voucher?.well?.id"></household-associations>
    </mat-tab>

    <!-- Well -->
    <mat-tab label="Well">
      <mat-card>
        <br />

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <div><strong>OHA Well Id</strong>:&nbsp;</div>
          <br />
          <div fxFlex>
            <span *ngIf="voucher.well != null">
              <a [routerLink]="['/well/edit/', voucher?.well?.id]" title="Edit Well" mat-dialog-close="Cancel">{{voucher?.well?.id}}</a>
            </span>
            &nbsp;
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <br />
          <br />
          <div><strong>Address:&nbsp;</strong></div>
          <br />
          <div fxFlex>{{voucher?.well?.address1}} {{voucher?.well?.city}} {{voucher?.well?.state}}
            {{voucher?.well?.zip}} &nbsp;</div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <br />
          <br />
          <div><strong>County:&nbsp;</strong></div>
          <br />
          <div fxFlex>{{voucher?.well?.county}} &nbsp;</div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <br />
          <br />
          <div><strong>Well Tag:&nbsp;</strong></div>
          <br />
          <div fxFlex>{{voucher?.well?.tag}} &nbsp;</div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <br />
          <br />
          <div><strong>Well Log:&nbsp;</strong></div>
          <br />
          <div fxFlex>{{voucher?.well?.wellLog}} &nbsp;</div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-around center">
          <br />
          <br />
          <div><strong>Coordinates:&nbsp;</strong></div>
          <br />
          <div fxFlex>{{voucher?.well?.latitude}} <span *ngIf="voucher?.well?.latitude != null && voucher?.well?.longitude != null">/</span> {{voucher?.well?.longitude}} &nbsp;</div>
        </div>

      </mat-card>
    </mat-tab>

    <!-- Samples -->
    <mat-tab label="Well Samples">
      <list-samples [wellId]="voucher?.well?.id"></list-samples>
    </mat-tab>

    <!-- Retests -->
    <mat-tab label="Retest Schedule">
      <list-retests [voucherId]="voucher?.id"></list-retests>
    </mat-tab>
  </mat-tab-group>
</div>